import { fetch } from '../utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryLookBooks(
  {
    name, topicId, page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/look-books`,
    method: 'get',
    params: {
      name,
      topicId,
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryLookBook(lookBookId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/look-books/${lookBookId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  name
 * @param  coverPath
 * @param  topImagePath
 * @param  topicId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addLookBook(
  {
    name,
    description,
    coverPath,
    dropImagePath,
    topImagePath,
    topicId,
    nameEn,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/look-books`,
    method: 'post',
    data: {
      name,
      description,
      coverPath,
      dropImagePath,
      topImagePath,
      topicId,
      nameEn,
    },
  });
}

/**
 * 更新
 * @param lookBookId
 * @param  name
 * @param  coverPath
 * @param  topImagePath
 * @param  topicId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateLookBook(lookBookId, {
  name,
  description,
  coverPath,
  type,
  topVideoPath,
  dropImagePath,
  topImagePath,
  topicId,
  nameEn,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/look-books/${lookBookId}`,
    method: 'patch',
    data: {
      name,
      description,
      coverPath,
      type,
      topVideoPath,
      dropImagePath,
      topImagePath,
      topicId,
      nameEn,
    },
  });
}

/**
 * 删除
 * @param lookBookId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteLookBook(lookBookId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/look-books/${lookBookId}`,
    method: 'delete',
  });
}

/**
 * 上移
 * @param lookBookId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _upLookBook(lookBookId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/look-books/${lookBookId}/up`,
    method: 'patch',
  });
}

/**
 * 下移
 * @param lookBookId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _downLookBook(lookBookId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/look-books/${lookBookId}/down`,
    method: 'patch',
  });
}

export default {};
